/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { usePlace } from '../../_load/PlaceLoader'
import EditAssetsForm from '../../../../assets/bulkEdit/EditAssetsForm'
import AssetsPlaceLoader, { usePlaceAssets } from './_load/AssetsPlaceLoader'
import { PermissionChecker } from '../../../../session'

const noPaddingStyle = css`
  margin-left: -1.75rem;
  margin-right: -1.75rem;
`

const AssetsContent = () => {
  const placeAssets = usePlaceAssets()

  return <EditAssetsForm disabled={true} externalAssets={placeAssets} enableMultiEdit={true} />
}

const Assets = () => {
  const place = usePlace()

  return (
    <PermissionChecker module="place" name="edit">
      <AssetsPlaceLoader placeId={place?.id}>
        <div css={noPaddingStyle}>
          <AssetsContent />
        </div>
      </AssetsPlaceLoader>
    </PermissionChecker>
  )
}

export default Assets
